<template>
    <div class="d-breadcrumbs">
        <div
            v-for="(breadcrumb, index) in breadcrumbs"
            :key="index"
            class="item"
        >
            <div class="text">
                <Link
                    v-if="index !== breadcrumbs.length - 1"
                    :href="breadcrumb.href"
                >
                    {{ __(breadcrumb.text, sidebarTranslationParameters) }}
                </Link>
                <span v-else>{{ __(breadcrumb.text, sidebarTranslationParameters) }}</span>
            </div>
            <div
                v-if="index !== breadcrumbs.length - 1"
                class="arrow"
            >
                <DIcon name="arrow-right" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DBreadcrumbs',
    props: {
        breadcrumbs: {
            type: Array,
            default: () => { return [] }
        }
    },
    computed: {
        sidebarTranslationParameters () {
            return this.$page.props.sidebarTranslationParameters
        }
    }
}
</script>

<style lang="scss" scoped>
.d-breadcrumbs {
    display: flex;
    grid-gap: 15px;
    align-items: center;
    padding-bottom: 15px;
    margin-top: -10px;

    & .item {
        align-items: center;
        display: flex;
        grid-gap: 15px;

        & a {
            color: rgba(0,0,0,0.4);
            transition: 0.2s ease-in-out all;

            &:hover {
                color: #000;
                text-decoration: none;
            }
        }
        & span {
            font-weight: 600;
        }
        & .arrow {
            color: #222;
            opacity: 0.4;
        }
    }
}
</style>
